import { AddressMessages } from "@/messages/address.messages";
import { SelectData } from "@/types/form.types";

export const COUNTRY_OPTIONS = (messages: AddressMessages): SelectData<string>[] => [
  { value: "BRASIL", label: messages.addressBrazilOption },
];
